import ModelListPage from "components/ui/customs/generics/ModelListPage";
import BackofficeHome from "./BackofficeHome";
import BackofficeLayout from "./BackofficeLayout";
import ModelViewPage from "components/ui/customs/generics/ModelViewPage";
import ModelViewPageFromParent from "components/ui/customs/generics/ModelViewPageFromParent";
import ModelCreateModal from "components/ui/customs/generics/ModelCreateModal";
import CaptableViewPage from "./pages/CaptableView";
import DealHome from "./pages/DealHome";
import FundHome from "./pages/FundHome";
import DealFinancials from "./pages/DealFinancials";

const dealSubPages = [
  {
    title: "Home",
    pageTitle: (deal) => `${deal?.name || "Deal : no Name"}`,
    path: "home",
    type: "view",
    Content: DealHome,
  },
  {
    title: "Financials",
    pageTitle: (deal) => `${deal?.name || "Deal : no Name"}`,
    path: "financials",
    type: "view",
    Content: DealFinancials,
  },
  {
    title: "Detail",
    pageTitle: (deal) => `${deal?.name || "Deal : no Name"}`,
    path: "detail",
    type: "view",
    Content: ModelViewPage,
    config: true,
  },
  {
    title: "Information",
    pageTitle: (deal) => `${deal?.name || "Deal : no Name"}`,
    path: "information",
    type: "view",
    modelName: "reporting.DealInformation",
    idFromParent: (data) => data.deal_information_id,
    itemCreateModal: ModelCreateModal({
      modelName: "reporting.DealInformation",
      initialValuesFromParent: (data) => ({
        deal: data.id,
      }),
    }),
    Content: ModelViewPageFromParent,
    config: true,
  },
  {
    title: "Reporting",
    pageTitle: (deal) => `${deal?.name || "Deal : no Name"}`,
    path: "reporting",
    type: "view",
    modelName: "reporting.DealReporting",
    idFromParent: (data) => data.deal_reporting_id,
    itemCreateModal: ModelCreateModal({
      modelName: "reporting.DealReporting",
      initialValuesFromParent: (data) => {
        return {
          deal: data.id,
        };
      },
    }),
    Content: ModelViewPageFromParent,
    config: true,
  },
  {
    title: "Exit",
    pageTitle: (deal) => `${deal?.name || "Deal : no Name"}`,
    path: "exit",
    type: "view",
    modelName: "reporting.DealExit",
    idFromParent: (data) => data.deal_exit_id,
    itemCreateModal: ModelCreateModal({
      modelName: "reporting.DealExit",
      initialValuesFromParent: (data) => {
        return {
          deal: data.id,
        };
      },
    }),
    Content: ModelViewPageFromParent,
    config: true,
  },
  {
    title: "Operations",
    pageTitle: (deal) => `${deal?.name || "Deal : no Name"}`,
    path: "operations",
    type: "list",
    keyName: "operationId",
    Content: ModelListPage,
    defaultFilter: (deal) => ({
      items: [{ field: "deal", operator: "is", value: deal.id }],
    }),
    modelName: "operations.Operation",
    itemCreateModal: ModelCreateModal({
      modelName: "operations.Operation",
      initialValuesFromParent: (data) => {
        return {
          deal: data.id,
        };
      },
    }),
    subPages: [
      {
        title: "Operation details",
        pageTitle: (operation) => `${operation?.name || "New Operation"}`,
        path: "operation_detail",
        type: "view",
        Content: ModelViewPage,
      },
    ],
  },
  {
    title: "Captable",
    pageTitle: (deal) => `${deal?.name || "Deal : no Name"}`,
    path: "captables",
    type: "list",
    keyName: "captableId",
    Content: ModelListPage,
    defaultFilter: (deal) => ({
      items: [{ field: "deal", operator: "is", value: deal.id }],
    }),
    itemCreateModal: ModelCreateModal({
      modelName: "reporting.CaptableLight",
      initialValuesFromParent: (data) => ({
        deal: data.id,
      }),
    }),
    modelName: "reporting.CaptableLight",
    subPages: [
      {
        title: "Captable details",
        path: "detail",
        type: "view",
        pageTitle: (captable) => `${captable?.name || "New Captable"}`,
        Content: CaptableViewPage,
      },
    ],
  },
  {
    title: "Board Meetings",
    pageTitle: (deal) => `${deal?.name || "Deal : no Name"}`,
    path: "board-meetings",
    type: "list",
    keyName: "boardMeetingId",
    Content: ModelListPage,
    defaultFilter: (deal) => ({
      items: [{ field: "deal", operator: "is", value: deal.id }],
    }),
    itemCreateModal: ModelCreateModal({
      modelName: "reporting.BoardMeeting",
      initialValuesFromParent: (data) => ({
        deal: data.id,
      }),
    }),
    modelName: "reporting.BoardMeeting",
    subPages: [
      {
        title: "Board Meeting details",
        path: "detail",
        type: "view",
        pageTitle: (boardMeeting) =>
          `${boardMeeting?.name || "New Board Meeting"}`,
        Content: ModelViewPage,
      },
    ],
  },
  {
    title: "Data Types",
    pageTitle: (deal) => `${deal?.name || "Deal : no Name"}`,
    path: "financial-data-types",
    type: "list",
    keyName: "financialDataTypeId",
    Content: ModelListPage,
    defaultFilter: (deal) => ({
      items: [{ field: "deal", operator: "is", value: deal.id }],
    }),
    itemCreateModal: ModelCreateModal({
      modelName: "financials.FinancialDataType",
      initialValuesFromParent: (data) => ({
        deal: data.id,
      }),
    }),
    modelName: "financials.FinancialDataType",
    config: true,
    subPages: [
      {
        title: "Detail",
        pageTitle: (financial_data_type) =>
          `${financial_data_type?.name || "New Financial Data Type"}`,
        path: "financial_data_type_detail",
        type: "view",
        Content: ModelViewPage,
      },
    ],
  },
];

const backofficeConfig = {
  type: "view",
  path: "backoffice",
  title: "Backoffice",
  Layout: <BackofficeLayout />,
  Content: BackofficeHome,
  subPages: [
    {
      type: "list",
      path: "deals",
      title: "Deals",
      keyName: "dealId",
      Content: ModelListPage,
      modelName: "backoffice.Deal",
      itemCreateModal: ModelCreateModal({ modelName: "backoffice.Deal" }),
      itemPath: (deal) => `${deal.id}`,
      subPages: dealSubPages,
      predefinedFilters: [
        {
          name: "My deals",
          filterModel: {
            items: [
              {
                field: "owner",
                operator: "is me",
              },
            ],
          },
        },
        {
          name: "My fund",
          filterModel: {
            items: [
              {
                field: "funds",
                operator: "is mine",
              },
            ],
          },
        },
      ],
    },
    {
      type: "list",
      title: "Funds",
      path: "funds",
      keyName: "fundId",
      Content: ModelListPage,
      modelName: "backoffice.Fund",
      itemCreateModal: ModelCreateModal({ modelName: "backoffice.Fund" }),
      itemPath: (fund) => `${fund.id}`,
      subPages: [
        {
          title: "Fund",
          pageTitle: (fund) => `Fund: ${fund?.name || "New Fund"}`,
          path: "fund",
          type: "view",
          Content: FundHome,
        },
        {
          title: "Detail",
          pageTitle: (fund) => `Fund: ${fund?.name || "New Fund"}`,
          path: "detail",
          type: "view",
          Content: ModelViewPage,
        },
        {
          title: "Operations",
          pageTitle: (fund) => `${fund?.name || "Fund : no Name"}`,
          path: "operations",
          type: "list",
          keyName: "operationId",
          Content: ModelListPage,
          defaultFilter: (fund) => ({
            items: [{ field: "deal__funds", operator: "is", value: fund.id }],
          }),
          modelName: "operations.Operation",
          subPages: [
            {
              title: "Detail",
              pageTitle: (operation) => `${operation?.name || "New Operation"}`,
              path: "operation_detail",
              type: "view",
              Content: ModelViewPage,
            },
          ],
        },
        {
          title: "Deals",
          type: "list",
          path: "deals",
          pageTitle: (fund) => `${fund?.name || "Fund : no Name"}`,
          keyName: "dealId",
          Content: ModelListPage,
          modelName: "backoffice.Deal",
          defaultFilter: (fund) => ({
            items: [{ field: "funds", operator: "is", value: fund.id }],
          }),
          itemCreateModal: ModelCreateModal({
            modelName: "backoffice.Deal",
          }),
          itemPath: (deal) => `${deal.id}`,
          subPages: dealSubPages,
        },
      ],
    },
    {
      type: "list",
      path: "operations",
      title: "Operations",
      keyName: "operationId",
      Content: ModelListPage,
      modelName: "operations.Operation",
      itemPath: (operation) => `${operation.id}`,
      subPages: [
        {
          title: "Operation",
          pageTitle: (operation) => `${operation?.name || "New Operation"}`,
          path: "view",
          type: "view",
          Content: ModelViewPage,
        },
      ],
    },
  ],
};

export default backofficeConfig;
